import { render, staticRenderFns } from "./WorkflowFilter.vue?vue&type=template&id=541628e4&scoped=true"
import script from "./WorkflowFilter.vue?vue&type=script&lang=js"
export * from "./WorkflowFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541628e4",
  null
  
)

export default component.exports